module.exports = __webpack_public_path__ + "static/media/won-sign.c221f80a.svg";